var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgViIcon = function SvgViIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10,
    fill: "none",
    viewBox: "0 0 14 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.53 9.248 5 8.718l-.53.53a.75.75 0 0 0 1.06 0M5 7.657l-3.47-3.47a.75.75 0 0 0-1.06 1.06l4 4 .53-.53.53.53 7.718-7.717a.75.75 0 0 0-1.06-1.06z",
    clipRule: "evenodd"
  })));
};
export default SvgViIcon;